import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { formatLongDate } from "@/lib/format";

export const AvvisiBanner = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/avvisi")
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <div className="bg-wood text-cream" data-testid="avvisi-banner">
      <div className="container-ed py-3 flex flex-wrap items-center gap-x-6 gap-y-1">
        <span className="inline-flex items-center gap-2 text-gold">
          <CalendarClock size={15} strokeWidth={1.5} />
          <span className="eyebrow text-gold">Avvisi</span>
        </span>
        {items.map((a) => (
          <p key={`${a.date}-${a.kind}`} className="text-xs md:text-sm" data-testid={`avviso-${a.date}`}>
            <span className="capitalize">{formatLongDate(a.date)}</span>:{" "}
            <span className={a.kind === "open" ? "text-gold" : "text-cream/80"}>{a.text.toLowerCase()}</span>
          </p>
        ))}
      </div>
    </div>
  );
};

export default AvvisiBanner;
